import React from 'react';

type SymbolsKlarnaColorIconProps = {
  width?: number;
  height?: number;
} & React.SVGProps<SVGSVGElement>;

const DIMENSIONS = {
  width: 48,
  height: 25,
  aspect: 48 / 25,
};

export const SymbolsKlarnaColorIcon = ({
  width = DIMENSIONS.width,
  height = DIMENSIONS.height,
}: SymbolsKlarnaColorIconProps) => {
  let effectiveWidth = width;
  let effectiveHeight = height;

  if (height > width) {
    effectiveWidth = height * DIMENSIONS.aspect;
  } else if (width > height) {
    effectiveHeight = width / DIMENSIONS.aspect;
  }

  return (
    <svg
      width={effectiveWidth}
      height={effectiveHeight}
      viewBox="0 0 48 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V21C48 23.2091 46.2091 25 44 25H4C1.79086 25 0 23.2091 0 21V4Z" fill="#F8B7C7" />
      <path d="M5.51369 8.5V16.3309H4.5V8.5H5.51369ZM6.95427 12.7852L7.33972 12.4938L7.34059 12.4932C8.62118 11.5207 9.41073 10.0884 9.54805 8.5H10.5208C10.4044 10.0901 9.734 11.5507 8.62747 12.6585L8.32548 12.9609L8.5771 13.3063L10.7805 16.3309H9.53596L6.95427 12.7852ZM32.9811 16.3398H32.1706V13.6172C32.1706 13.091 32.0345 12.6106 31.7086 12.2583C31.3773 11.9003 30.9163 11.7463 30.4164 11.7463C29.9463 11.7463 29.476 11.8908 29.1183 12.2223C28.754 12.56 28.5563 13.0457 28.5563 13.6261V16.3309H27.7281V11.224H28.5298V11.4095V12.9482L29.4343 11.7034C29.7697 11.2419 30.2794 11.0549 30.9022 11.0549C32.1291 11.0549 32.9811 11.845 32.9811 12.9496V16.3398ZM39.6159 12.0722V11.224H40.4265V16.3309H39.6159V15.4827L38.8305 16.0286C38.4005 16.3275 37.8815 16.5 37.3142 16.5C35.8277 16.5 34.617 15.2855 34.617 13.7774C34.617 12.2694 35.8277 11.0549 37.3142 11.0549C37.8815 11.0549 38.4005 11.2274 38.8305 11.5263L39.6159 12.0722ZM25.0016 11.8207C25.1814 11.5866 25.4968 11.3842 25.8802 11.2865V12.0582C25.552 12.1292 25.2167 12.2699 24.9286 12.4764C24.4868 12.7931 24.1138 13.2997 24.1138 13.9822V16.3309H23.2503V11.224H24.105V11.5163V12.989L25.0016 11.8207ZM13.7451 16.3309H12.8462V8.5H13.7451V16.3309ZM20.4859 11.224H21.2964V16.3309H20.4859V15.4827L19.7005 16.0286C19.2705 16.3275 18.7515 16.5 18.1841 16.5C16.6976 16.5 15.487 15.2855 15.487 13.7774C15.487 12.2694 16.6976 11.0549 18.1841 11.0549C18.7515 11.0549 19.2705 11.2274 19.7005 11.5263L20.4859 12.0722V11.224ZM16.1915 13.7774C16.1915 14.9383 17.1702 15.8442 18.3343 15.8442C19.4984 15.8442 20.477 14.9383 20.477 13.7774C20.477 12.6166 19.4984 11.7107 18.3343 11.7107C17.1702 11.7107 16.1915 12.6166 16.1915 13.7774ZM35.3216 13.7774C35.3216 14.9383 36.3002 15.8442 37.4643 15.8442C38.6227 15.8442 39.6175 14.9431 39.6071 13.775C39.6057 12.6153 38.6276 11.7107 37.4643 11.7107C36.3002 11.7107 35.3216 12.6166 35.3216 13.7774Z" fill="#121111" stroke="black" />
      <path d="M42.2214 15.8161C42.2214 15.4564 42.5135 15.1677 42.8607 15.1677C43.2104 15.1677 43.5 15.4501 43.5 15.8161C43.5 16.1757 43.2079 16.4644 42.8607 16.4644C42.5135 16.4644 42.2214 16.1757 42.2214 15.8161Z" fill="#121111" stroke="black" />
    </svg>

  );
};
